<template>
  <div class="reports-schedule">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <div v-if="value && daysLabel" class="mr-2">
        <span class="badge text-capitalize">{{ daysLabel }}</span> c
        <span class="badge">{{ value.from }}</span> по
        <span class="badge">{{ value.till }}</span> каждые
        <span class="badge">{{ value.every }}</span> ч
      </div>
      <div class="text-muted mr-2" v-else>Нет</div>
      <button class="btn btn-sm btn-outline-light" @click.stop="edit">Редактировать</button>
    </div>
  </div>
</template>

<script>
  import { cloneDeep, range, isEqual } from 'lodash'
  import moment from 'moment'
  import ReportsScheduleEditModal from './reports-schedule-edit-modal.vue'

  export default {
    name: 'ReportsSchedule',
    props: {
      value: {},
      id: {},
    },
    methods: {
      edit () {
        this.$root
          .showModal(ReportsScheduleEditModal, {
            value: (this.value && cloneDeep(this.value)) || {days: []},
            ids: [this.id],
          })
          .then((value) => {
            if (value) {
              // this.value = value
              this.$emit('input', value)
            }
          })
      },
    },
    computed: {
      daysLabel () {
        if (!this.value) return null
        if (isEqual(this.value.days, range(0, 5))) {
          return 'Будни'
        } else if (isEqual(this.value.days, range(5, 7))) {
          return 'Выходные дни'
        } else if (isEqual(this.value.days, range(0, 7))) {
          return 'Ежедневно'
        } else {
          return (this.value.days).map((d) => {
            return moment().weekday(d).format('dd')
          }).join(' ')
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .reports-schedule {
    .badge {
      display: inline;
      font-size: 1em;
      background-color: $gray-lightest;
      font-weight: normal;
      color: inherit;
    }
    .btn {
      display: inline;
      vertical-align: baseline;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/reports-schedule.vue